module.exports = __webpack_public_path__ + "img/responsive hospitium-04.a08764ab.jpg";